import React from 'react'

export default function BitSli() {
  return (
    <div>
        <div className="bithu_owl_carousel_sect">
  <div className="bithu_owl_carousel_content">
    <div className="home1-avater-slider">
      <ul>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli4.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli1.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli2.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli3.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli4.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli5.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli6.png" alt="img" />
          </div>
        </li>
      </ul>
      <ul>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli7.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli8.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli9.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli1.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli2.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli3.png" alt="img" />
          </div>
        </li>
        <li>
          <div className="item bg-2">
            <img src="assets/images/sli4.png" alt="img" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

    </div>
  )
}
